import { engineComponent, EngineComponentFactory, Logger } from "neo-common";
import { ComponentTypes } from "./ComponentTypes";

/**
 * Registers action sets, their elements, actions and dispatch action on event.
 *
 * @class ActionSet
 * @author Marek Turkovic
 */
@engineComponent(ComponentTypes.ActionSet)
export class ActionSet {
    /**
     * Registered actions per action block
     * @type {{}}
     */
    static ActionSets: { [id: string]: any } = {};

    /**
     * Elements that we want to control.
     * @type {{}}
     */
    static ElementsToLink: { [id: string]: any } = {};

    /**
     * Elements containing attributes Action, Event, ActionCase. These elements emits actions.
     * @type {{}}
     */
    actionElements: { [id: string]: any } = {};

    /**
     * xml nodes added to object by case name
     */
    cases: Object = {};

    /**
     * Registers action sets, their elements and actions
     * @param node
     */
    public RegisterActionSet(node: Element): void {
        ActionSet.getNodesList(node.firstElementChild)
            .reverse()
            .forEach((actionSetNode: Element) => {
                switch (actionSetNode.nodeName) {
                    case "Elements":
                        ActionSet.getNodesList(actionSetNode.firstElementChild)
                            .reverse()
                            .forEach((elementNode: Element) => {
                                this.actionElements[elementNode.nodeName] = elementNode;
                            });

                        break;
                    case "Actions":
                        ActionSet.getNodesList(actionSetNode.firstElementChild)
                            .reverse()
                            .forEach((actionCase: Element) => {
                                if (!actionCase.hasAttribute(ActionSetAttributes.CASE)) {
                                    return;
                                }

                                if (this.cases[actionCase.getAttribute(ActionSetAttributes.CASE)] !== null) {
                                    this.cases[actionCase.getAttribute(ActionSetAttributes.CASE)] = actionCase;
                                } else {
                                    if (DEBUG) {
                                        this.log(
                                            "ERROR case " +
                                                actionCase.getAttribute("Case") +
                                                " already exist in ActionSet " +
                                                node.nodeName,
                                        );
                                    }
                                }
                            });
                        break;
                }
            });

        ActionSet.ActionSets[node.nodeName] = this;
    }

    /**
     * Recursively extracts sibling nodes.
     * @method getNodesList
     * @param node Element
     * @param nodeList Array<Element>
     * @return Array<Element>
     */
    private static getNodesList(node: Element, nodeList: Array<Element> = []): Array<Element> {
        if (!node) {
            return nodeList;
        }

        if (node.nextElementSibling) {
            nodeList = ActionSet.getNodesList(node.nextElementSibling, nodeList);
        }

        return nodeList.concat(node);
    }

    /**
     * Perform set of actions on main element throught linked element.
     *
     * @param action
     * @constructor
     */
    public DispatchEvent(action: string): void {
        ActionSet.getNodesList(this.cases[action].firstElementChild)
            .reverse()
            .forEach((elementNode: Element) => {
                const linkedElement = this.actionElements[elementNode.nodeName];
                const classAttribute = linkedElement.hasAttribute("Class") ? linkedElement.getAttribute("Class") : "";

                if (classAttribute === "") {
                    if (DEBUG) {
                        this.log("WARNING element with name: " + linkedElement.nodeName + " has no class");
                    }
                    return;
                }

                if (!EngineComponentFactory.isTypeOf(classAttribute, ComponentTypes.LinkedElement)) {
                    return;
                }

                const element: any = EngineComponentFactory.get(classAttribute);
                element.create(linkedElement, elementNode);
            });
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    protected log(s: string): void {
        if (DEBUG) {
            let compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}

export const ActionSetAttributes = {
    CASE: "Case",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/ActionSet.ts
 **/